import { useMutation } from '@apollo/client';
import type { UseDealInsightsFilterOptions } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import { filtersFromApiResponse } from '@openx/components-deal/lib/utils/dealInsightsApiUtils';
import type { DealInsightsFilterOptionsApi } from '@openx/types/dealInsights';
import { useEffect, useState } from 'react';
import { DealInsightsFilterOptionsDocument } from '../../../../graphql/mutation/deals/DealInsightsFilterOptions.generated';

export const useDealInsightsFilterOptions: UseDealInsightsFilterOptions = (param, enabled = true) => {
  const [data, setData] = useState<DealInsightsFilterOptionsApi>();

  const [getDealInsightsFilterOptions, { loading }] = useMutation(DealInsightsFilterOptionsDocument);

  const stringParams = enabled ? JSON.stringify(param) : '';

  // biome-ignore lint/correctness/useExhaustiveDependencies: There is an infinite rerender issue when listening to params changes without stringifying
  useEffect(() => {
    const getData = async () => {
      if (!stringParams.length) {
        return;
      }

      const res = await getDealInsightsFilterOptions({ variables: param });
      setData(res.data?.dealInsightsFilterOptions as DealInsightsFilterOptionsApi);
    };

    getData();
  }, [stringParams]);

  return {
    loading: loading,
    data: filtersFromApiResponse(data),
  };
};
